import { createFileRoute } from '@tanstack/react-router';
import { RouteGuard } from '../../lib/route-guard.js';
import { BomCreateWizard } from '../../modules/bom/bom-create-wizard.js';

export const Route = createFileRoute('/boms/new')({
  component: NewBomPage,
});

// eslint-disable-next-line react-refresh/only-export-components
function NewBomPage() {
  return (
    <RouteGuard route="/boms/new">
      <div>
        <BomCreateWizard />
      </div>
    </RouteGuard>
  );
}
